import { render, staticRenderFns } from "./EnrollmentEdit.vue?vue&type=template&id=89530f74&scoped=true&lang=pug&"
import script from "./EnrollmentEdit.vue?vue&type=script&lang=js&"
export * from "./EnrollmentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89530f74",
  null
  
)

export default component.exports